module.exports = __webpack_public_path__ + "static/media/descriptionplaceholder1.b64eefdc.png";